import absoluteUrl from 'next-absolute-url'

import PolicyTechnician from 'containers/PolicyTechnician'

import MetaTags from 'components/MetaTags'
import Layout from 'components/Layout'

export default function Index({ canonical }) {
  const metaTitle = '24FIX | นโยบายความเป็นส่วนตัว'
  const metaDescription = '24FIX | นโยบายความเป็นส่วนตัว'

  return (
    <>
      <MetaTags title={metaTitle} description={metaDescription} pathUrl={canonical} />

      <Layout>
        <PolicyTechnician />
      </Layout>
    </>
  )
}

export async function getServerSideProps(context) {
  const { req } = context
  const { origin } = absoluteUrl(req)

  return {
    props: JSON.parse(
      JSON.stringify({
        canonical: `${origin}/policy-for-technician`,
      })
    ),
  }
}
